import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import Tabs from "components/Tabs";
import { EMerchandisingReports } from "types/MerchandisingPage";
import { ERoutesAnchors } from "types/Routes";
import styles from "pages/Merchandising/styles.module.scss";
import { useAppSelector } from "hooks/store";
import { selectUserData } from "store/auth/authSlice";
import TipReportV2 from "pages/v2/Merchandising/TipReport";
import ChannelStatsV2 from "pages/v2/Merchandising/ChannelStats";
import PreShootReport from "pages/v2/Merchandising/PreShootReport";
import DealRatingsV2 from "pages/v2/Merchandising/DealRatings";

const Tables = () => {

  const [searchParams, setSearchParams] = useSearchParams();
  const activeTable = (searchParams.get("activeTable") as EMerchandisingReports) ?? EMerchandisingReports.ChannelStats;

  const userAuth = useAppSelector(selectUserData);

  const onChangeActiveTable = useCallback(
    (_: number, newActiveTableId?: string | number) =>
      setSearchParams({ activeTable: newActiveTableId as string }),
    [setSearchParams]
  );

  const getTableTabs = useCallback(() => ([
    ...(userAuth.inventory.value === 'used' && userAuth.dealerV2.third_party_provider.length > 0 && !userAuth.dealerV2.is_lite ? [
      { id: EMerchandisingReports.DealRatings, label: "Deal Ratings by Channel" },
      { id: EMerchandisingReports.TipReport, label: "Tip Report" },
    ] : []),
    { id: EMerchandisingReports.ChannelStats, label: "Channel Stats Report" },
    { id: EMerchandisingReports.PreShootReport, label: "Pre Shoot Report" },
  ]), [userAuth.inventory.value, userAuth.dealerV2.third_party_provider, userAuth.dealerV2.is_lite]);

  const activeTableIndex = useMemo(
    () => getTableTabs().findIndex((tableTab) => tableTab.id === activeTable),
    [activeTable, getTableTabs]
  );

  return (
    <div id={ERoutesAnchors.MerchandisingTables} className={styles.tables}>
      <Tabs
        className={styles["tables__tabOptions"]}
        active={activeTableIndex !== -1 ? activeTableIndex : 0}
        tabs={getTableTabs()}
        onClickTab={onChangeActiveTable}
      />
      {activeTable === EMerchandisingReports.DealRatings && (
        <div className={styles["tables__tab--dealRatingsTable"]}>
          <DealRatingsV2 />
        </div>
      )}
      {activeTable === EMerchandisingReports.TipReport && (
        <div className={styles["tables__tab--tipReportTable"]}>
          <TipReportV2 />
        </div>
      )}
      {activeTable === EMerchandisingReports.ChannelStats && (
        <div className={styles["tables__tab--channelStatsTable"]}>
          <ChannelStatsV2 />
        </div>
      )}
      {activeTable === EMerchandisingReports.PreShootReport && (
        <div className={styles["tables__tab--preShootReportTable"]}>
          <PreShootReport />
        </div>
      )}
    </div>
  );
};
export default Tables;
